import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список риелторов для списка рейтинга
 */
export const selectRealtorRatingList = ({ realtorRatingList }: IApplicationState) => realtorRatingList;
